/**
 * @author alteredq / http://alteredqualia.com/
 *
 * Modifications copyright Higharc Inc. 2019-2020.
 */
import type { WebGLRenderer, WebGLRenderTarget } from "three";
import type { EffectComposer } from "./effectComposerTypes";

// Re-export types from shared module for backwards compatibility
export type { EffectComposer, EffectComposerPassInterface } from "./effectComposerTypes";
export { effectComposerSetSize } from "./effectComposerTypes";

export function effectComposerHasEnabledPasses(effects: EffectComposer): boolean {
  for (const effect of effects) {
    if (Array.isArray(effect)) {
      for (const subEffect of effect) {
        if (subEffect.enabled) {
          return true;
        }
      }
    } else if (effect.enabled) {
      return true;
    }
  }
  return false;
}

export function effectComposerRender(
  effects: EffectComposer,
  renderer: WebGLRenderer,
  renderTarget: WebGLRenderTarget | null,
): void {
  for (const effect of effects) {
    if (Array.isArray(effect)) {
      for (const subEffect of effect) {
        if (subEffect.enabled) {
          subEffect.render(renderer, renderTarget ?? null);
        }
      }
    } else if (effect.enabled) {
      effect.render(renderer, renderTarget ?? null);
    }
  }
}
